import React, { useMemo, useState } from 'react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL || (window.location.hostname === 'localhost' ? 'http://localhost:5000' : 'https://api.pluckr.ai');

const StopBurningCreditsCTA = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success

  const isDisabled = status === 'loading' || status === 'success';

  const buttonLabel = useMemo(() => {
    if (status === 'loading') return 'Joining...';
    if (status === 'success') return 'You\'re in!';
    return 'Join the waitlist';
  }, [status]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    setStatus('loading');

    try {
      const response = await fetch(`${API_URL}/api/waitlist/join`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
          source: 'mobile-stop-burning',
        }),
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok || payload?.success === false) {
        throw new Error(payload?.message || 'Failed to join waitlist');
      }

      setStatus('success');
      setEmail('');

      toast.success(payload?.message || "You're on the waitlist.");
    } catch (err) {
      setStatus('idle');
      toast.error(err?.message || 'Something went wrong');
    }
  };

  return (
    <section className="bg-[var(--pluckr-bg-soft)] px-6 py-10" data-testid="mobile-stop-burning-cta">
      <div className="max-w-[520px] mx-auto">
        <h2
          className="text-[#1a1a1a] dark:text-white text-[42px] leading-[1.2] tracking-tight"
          style={{ fontFamily: "'Martel Sans', sans-serif", fontWeight: 700 }}
        >
          <span className="block">Stop burning credits.</span>
          <span className="block">
            <span className="relative inline-block">
              Start building
              <span className="absolute left-0 -bottom-1 h-[3px] w-full bg-[var(--pluckr-green)]" aria-hidden="true" />
            </span>
            .
          </span>
        </h2>

        <div className="mt-8">
          <div className="text-[var(--pluckr-green)] text-[26px] font-semibold">Join waitlist</div>

          <form onSubmit={handleSubmit} className="mt-4">
            <div className="w-full bg-white dark:bg-[#282929] border border-[#d9d9d9] dark:border-white/15 rounded-full overflow-hidden flex items-stretch">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email address"
                className="flex-1 min-w-0 px-6 py-4 text-[13px] text-[#1a1a1a] dark:text-white outline-none bg-transparent placeholder:text-[#b7bcc7] dark:placeholder:text-white/40"
                disabled={isDisabled}
                inputMode="email"
                autoComplete="email"
              />
              <button
                type="submit"
                disabled={isDisabled}
                className="flex-shrink-0 whitespace-nowrap px-6 min-w-[170px] bg-[#9be38f] text-[#1a1a1a] font-semibold text-[15px] sm:text-[18px] rounded-full"
                style={{ boxShadow: '0 0 0 3px rgba(155,227,143,0.25) inset' }}
              >
                {buttonLabel}
              </button>
            </div>

            <div className="mt-4 text-[16px] text-[#5a5a5a] dark:text-[#e0e0e0]">No spam. Early access only.</div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default StopBurningCreditsCTA;
